export interface AuditorExportDialogProps {
  isOpen: boolean;
  onClose: () => void;
  companyID?: string;
  onExportComplete?: (result: any) => void;
  onError?: (error: Error) => void;
  showLoading?: (show: boolean) => void;
}

// Legacy static frameworks (kept for backwards compatibility)
export const LEGACY_FRAMEWORKS = [
  { id: 'dispcontrols', label: 'DISP', dbKey: 'disp' },
  { id: 'e8controls', label: 'Essential 8', dbKey: 'essentialeight' },
  { id: 'iso27701', label: 'ISO 27701', dbKey: 'iso27701' },
  { id: 'iso270012022annexacontrols', label: 'ISO 27001:2022', dbKey: 'iso27001-2013' },
  { id: 'iso420012023controls', label: 'ISO 42001', dbKey: 'iso42001' },
  { id: 'qgov-is18', label: 'QGOV IS18', dbKey: 'is18' },
  { id: 'pacontrols', label: 'Privacy Act', dbKey: 'privacyact' },
  { id: 'soc2controls', label: 'SOC 2', dbKey: 'soc2' },
  { id: 'ism', label: 'ISM', dbKey: 'ism' },
  { id: 'smb1001controls', label: 'SMB1001', dbKey: 'smb1001' },
] as const;

// Re-export as FRAMEWORKS for backwards compatibility
export const FRAMEWORKS = LEGACY_FRAMEWORKS;

export type FrameworkId = string;

export interface FrameworkOption {
  id: string;
  label: string;
  slug?: string;
  dbKey?: string;
  checked: boolean;
}

// Audit types matching the original dialog
export const AUDIT_TYPES = [
  { value: '.', label: 'Select Audit Type', disabled: true },
  { value: 'Internal Audit', label: 'Internal Audit' },
  { value: 'External Audit', label: 'External Audit' },
] as const;

export type AuditType = typeof AUDIT_TYPES[number]['value'];

export interface DateRange {
  startDate: string;
  endDate: string;
}

export interface AuditInfo {
  typeOfAudit: AuditType;
  startDate: string;
  endDate: string;
}
